import React from 'react';
import './footer.css'

const Footer: React.FC = () => {
  return(
    <div className="footer">
      <hr />
      🌞 <a href="https://en.wikipedia.org/wiki/Tower_of_Hanoi">Wikipedia</a> | <a href="https://github.com/jvuor/hanoi-towers">Github</a> 🌞
    </div>
  )
}

export default Footer;
